<ngx-spinner [showSpinner]="false" bdColor="rgba(255,255,255,0.5)" type="ball-scale-multiple">
  <div class="container">
    <div class="loader">
      <div class="loader--dot"></div>
      <div class="loader--dot"></div>
      <div class="loader--dot"></div>
      <div class="loader--dot"></div>
      <div class="loader--dot"></div>
      <div class="loader--dot"></div>
    </div>
  </div>
</ngx-spinner>
<router-outlet></router-outlet>
